import { forwardRef, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import AppInput from "./AppInput.tsx";

interface PasswordInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <AppInput
        ref={ref}
        {...props}
        type={visible ? "text" : "password"}
        rightIcon={
          <button
            type="button"
            onClick={() => setVisible((prev) => !prev)}
            className="
              flex items-center justify-center
              text-[rgb(var(--text-muted))]
              hover:text-[rgb(var(--text-primary))]
              transition-colors duration-200
            "
          >
            {visible ? (
              <VisibilityOffIcon fontSize="small" />
            ) : (
              <VisibilityIcon fontSize="small" />
            )}
          </button>
        }
      />
    );
  }
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;